export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE";

//*******************ADD TO CART ***************************//

export const ADD_TO_CART = "ADD_TO_CART";
export const UPDATE_CART = "UPDATE_CART";

//********FILTERED DATA**********/

export const FILTER_DATA = "FILTER_DATA";


//********WISHLIST DATA**********/
export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST"
